import manejadorRest from '@infotrack/presentacion-utilitarios/manejadorRest';
import { IRespuesta } from '@infotrack/presentacion-transversales/interfacesComunes';
import { negocio } from '../../../conexiones';
import IPlantillaImpresion from '../../../negocioRefactor/entidades/repositorio/IPlantillaImpresion';

export default class ModeloPlantillaImpresion {
    private NOMBRE_CONTROLADOR = 'PlantillaImpresion';

    public consultarListaPlantillaImpresionWeb(idEmpresa: string) {
        return manejadorRest<IRespuesta<IPlantillaImpresion>>(
            () => negocio.get(`${this.NOMBRE_CONTROLADOR}/ConsultarListaPlantillaImpresionWeb/${idEmpresa}`),
            true
        );
    }

    public consultarListaPlantillaImpresionMovil(idEmpresa: string) {
        return manejadorRest<IRespuesta<IPlantillaImpresion>>(
            () => negocio.get(`${this.NOMBRE_CONTROLADOR}/ConsultarListaPlantillaImpresionMovil/${idEmpresa}`),
            true
        );
    }

    public crearPlantillaImpresion(plantillaImpresion: IPlantillaImpresion) {
        return manejadorRest<IRespuesta<IPlantillaImpresion>>(
            () => negocio.post(`${this.NOMBRE_CONTROLADOR}/GuardarPlantillaImpresion`, plantillaImpresion),
            true
        );
    }

    public editarPlantillaImpresion(plantillaImpresion: IPlantillaImpresion) {
        return manejadorRest<IRespuesta<IPlantillaImpresion>>(
            () => negocio.put(`${this.NOMBRE_CONTROLADOR}/EditarPlantillaImpresion`, plantillaImpresion),
            true
        );
    }

    public eliminarPlantillaImpresion(filtro: Partial<IPlantillaImpresion>) {
        return manejadorRest<IRespuesta<IPlantillaImpresion>>(
            () => negocio.delete(`${this.NOMBRE_CONTROLADOR}/EliminarPlantillaImpresion`, filtro),
            true
        );
    }
}
